import React from 'react'
import gql from 'graphql-tag'
import { LabeledSelect, SpinningMask } from 'labguard-cdk'
import { useQuery } from 'react-apollo'
import { StickyNoteIcon } from 'src/components/common'

const query = gql`
  query ackCommentsInput {
    ackComments {
      id
      label
    }
  }
`

function AckCommentInput(props) {
  const { loading, data: { ackComments = [] } = {} } = useQuery(query)

  return (
    <SpinningMask loading={loading}>
      <LabeledSelect {...props} icon={StickyNoteIcon}>
        <option disabled value={''}>
          -
        </option>
        {ackComments.map(({ id, label }) => (
          <option key={id} value={id}>
            {label}
          </option>
        ))}
      </LabeledSelect>
    </SpinningMask>
  )
}

export default AckCommentInput
